function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#509e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v10H0V7.5Z",
    style: {
      fill: "#ef3340"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v5H0v-5Z",
    style: {
      fill: "#00b5e2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.25,
    cy: 15,
    r: 2.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.75,
    cy: 15,
    r: 1.875,
    style: {
      fill: "#ef3340"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75,13.75l.239.673.645-.306-.306.645.672.238-.673.239.306.645-.645-.306-.239.673-.239-.673-.645.306.306-.645-.671-.239.673-.239-.306-.645.645.306.238-.672Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/AZ.306d66eb9f339f2a078f0270728efefa.svg";
export { ForwardRef as ReactComponent };